module.exports = __webpack_public_path__ + "img/about_logo_11.1a526d42.png";